<template>
  <div v-if="!isUserVerified && isShowBanner" class="verification-bonus-banner">
    <UiBtn
      v-if="!noClose"
      class="verification-bonus-banner__btn-close"
      icon="common/close"
      icon-only
      tag="span"
      size="s"
      @click="isShowBanner = false"
    />
    <div class="verification-bonus-banner__content">
      <UiText
        class="verification-bonus-banner__content-title"
        font="promo-heading-3"
        :text="bonusTitle"
        color="typography-title01"
      />
      <UiText
        class="verification-bonus-banner__content-text"
        :font="isUserNothingVerified ? 'hero-display-5' : 'promo-heading-3'"
        color="typography-title04"
        :text="bonusText"
      />
    </div>
    <div class="verification-bonus-banner__img-block">
      <img class="verification-bonus-banner__img" src="/img/verifications/bonus-verification.webp" alt="fs" />
    </div>
    <img
      v-if="isUserNothingVerified"
      class="verification-bonus-banner__img-fog"
      src="/img/welcome-pack/fog/violet.webp"
      alt="fs"
    />
    <img
      v-else
      class="verification-bonus-banner__img-fog"
      src="/img/welcome-pack/fog/grey.webp"
      alt="fs"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'BonusBanner',
  props: {
    noClose: { type: Boolean, default: false },
  },
  data() {
    return {
      isShowBanner: true,
    }
  },
  computed: {
    ...mapGetters('user', ['isUserNothingVerified', 'isUserVerified']),
    ...mapGetters('promotions', ['get_bonusesListTriggered']),
    get_sufficientVerificationBonusFs() {
      if (!this.get_bonusesListTriggered?.sufficientVerification) return ''
      return this.get_bonusesListTriggered?.sufficientVerification[0]?.fs.spins_per_day || ''
    },
    bonusTitle() {
      return this.isUserNothingVerified ? this.$t('verification.bannerBonus.titleNotVerified') : this.$t('verification.bannerBonus.titlePartiallyVerified')
    },
    bonusText() {
      return this.isUserNothingVerified ? `${this.get_sufficientVerificationBonusFs} ФС` : `${this.$t('verification.bannerBonus.textPartiallyVerified')} ${this.get_sufficientVerificationBonusFs} ФС`
    },
  },
  mounted() {
    if (!Object.keys(this.get_bonusesListTriggered).length)
      this.fetch_bonusesListTriggered()
  },
  methods: {
    ...mapActions('promotions', ['fetch_bonusesListTriggered']),
  },
}
</script>
<style lang="scss" src="./style.scss" scoped></style>